(function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .service('FixationManagementCustomService',FixationManagementCustomService);

    FixationManagementCustomService.$inject = ['$http'];

    function FixationManagementCustomService($http) {

        var service = {
            findFixationUsages: findFixationUsages,
            findInvoicePrices: findInvoicePrices,
            findAllFixationOverPricing: findAllFixationOverPricing,
            findAllFixationOverApplied: findAllFixationOverApplied,
            findAllByContractId: findAllByContractId,
            findAllByContractNum: findAllByContractNum,
            findByPricingId: findByPricingId,
            findAllByPricingIsNull: findAllByPricingIsNull,
            fetchUniquePricingYears: fetchUniquePricingYears
        };

        return service;

        function findFixationUsages(pricingId) {
            var url = "api/management/fixation/usages/pricing/" + pricingId;
            return $http.get(url);
        }

        function findInvoicePrices(fixationId, contractId) {
            var url = "api/management/fixation/" + fixationId + "/usages/invoice-price/contract/" + contractId;
            return $http.get(url);
        }

        function findAllFixationOverPricing(isOver) {
            var url = "api/management/fixation/over-pricing/" + isOver;
            return $http(url);
        }

        function findAllFixationOverApplied(isOver) {
            var url = "api/management/fixation/over-applied/" + isOver;
            return $http(url);
        }

        function findAllByContractId(id) {
            var url = "api/management/fixation/contract/" + id;
            return $http(url);
        }

        function findAllByContractNum(contractNum) {
            var url = "api/management/fixation/contract/number/" + contractNum;
            return $http(url);
        }

        function findByPricingId(id) {
            var url = "api/management/fixation/pricing/" + id;
            return $http(url);
        }

        function findAllByPricingIsNull() {
            var url = "api/management/fixation/pricing/null";
            return $http(url);
        }

        function fetchUniquePricingYears() {
            var url = "api/management/fixation/pricing/years";
            return $http.get(url);
        }

    }
})();
